import { useAuth } from "@/lib/auth";
import { can, DENIED_MSG } from "@/lib/perms";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldAlert } from "lucide-react";

export default function RequirePerm({ p, children }) {
  const { user } = useAuth();
  if (can(user, p)) return children;
  return (
    <Card className="border-red-200 bg-red-50 max-w-xl" data-testid="permission-denied">
      <CardContent className="p-6 flex items-start gap-3 text-red-800">
        <ShieldAlert className="w-6 h-6 shrink-0" />
        <div>
          <div className="font-display text-lg font-bold">Accesso negato</div>
          <div className="text-sm mt-1" data-testid="permission-denied-message">{DENIED_MSG}</div>
        </div>
      </CardContent>
    </Card>
  );
}
